import React, { useCallback } from 'react'

import { useOrderProcessStep } from '../../../data/settings'
import { OrderProcessStep } from '../../../data/settings/models'
import { useSearchParam } from '../../../hooks'
import { DespatchAdviceTable } from './DespatchAdviceTable/DespatchAdviceTable'
import { InvoiceTable } from './InvoiceTable/InvoiceTable'
import { OrdersTable } from './OrdersTable'
import { Title } from './Title'

export const Orders: React.FC = () => {
  const { data: processStep } = useOrderProcessStep()
  const [searchParam, setSearchParam] = useSearchParam('search')

  const isVisibleOrderResponses = useCallback((): boolean => {
    return processStep !== undefined
      ? [
          OrderProcessStep.ORDER_RESPONSE,
          OrderProcessStep.DESPATCH_ADVICE,
          OrderProcessStep.INVOICE,
        ].includes(processStep)
      : true // fallback to true for orderresponses always to be visible
  }, [processStep])

  const isVisibleDespatchAdvices = useCallback((): boolean => {
    return processStep !== undefined
      ? [OrderProcessStep.DESPATCH_ADVICE, OrderProcessStep.INVOICE].includes(
          processStep,
        )
      : false
  }, [processStep])

  const isVisibleInvoices = useCallback((): boolean => {
    return processStep !== undefined
      ? [OrderProcessStep.INVOICE].includes(processStep)
      : false
  }, [processStep])

  return (
    <>
      <Title
        globalFilterValue={searchParam}
        setGlobalFilterValue={setSearchParam}
      />

      <OrdersTable
        globalFilterValue={searchParam}
        setGlobalFilterValue={setSearchParam}
        isVisible={isVisibleOrderResponses()}
      />

      <DespatchAdviceTable
        globalFilterValue={searchParam}
        setGlobalFilterValue={setSearchParam}
        isVisible={isVisibleDespatchAdvices()}
      />

      <InvoiceTable
        globalFilterValue={searchParam}
        setGlobalFilterValue={setSearchParam}
        isVisible={isVisibleInvoices()}
      />
    </>
  )
}
